import React from 'react';
import { useNavigate } from "react-router-dom";
import { Avatar, Col, Row, Card, Typography } from 'antd';
import { Image } from 'antd';
import Logo from '../../Components/Graphics/Logo';
import { formatCompanyLogoUrl } from '../../Api/companyApi';
import './PortfolioSquare.css';

const { Title, Paragraph } = Typography;

const PortfolioSquare = ({ portfolio, width = 300, height=220, maxLines=4 }) => {
    const navigate = useNavigate();
    const logoUrl = formatCompanyLogoUrl();
    const description = portfolio.attr.summary ?? '';

    const handleNavigate = () => {
        navigate(`/public/portfolio/${portfolio.id}`);
    };

    const isPortrait = height > width;

    return (
        <Card className="portfolio-square gapless"
              style={{ width, height }}
              onClick={handleNavigate}
              bordered={false}
        >
            {isPortrait ? (
                // Portrait Layout: Logo on top, title underneath
                <>
                    <Row justify="space-between" align={'middle'} className={'px-2'}>
                        <Col>
                            <Avatar
                                src={logoUrl}
                                alt="Company Logo"
                                style={{ width: '100%', height: 40, borderRadius: '0' }}
                                preview={false}
                            />
                        </Col>
                        <Col>
                            <Typography.Title className={'pt-1'} level={5}>{portfolio?.targets?.equity} / {portfolio?.targets?.fixed}</Typography.Title>
                        </Col>
                    </Row>
                    <Row justify="start" className={'px-2'}>
                        <Col>
                            <Typography.Text level={5} className="portfolio-title" style={{ textAlign: 'center' }}>
                                {portfolio.name}
                            </Typography.Text>
                        </Col>
                    </Row>
                </>
            ) : (
                // Landscape Layout: Logo and title in the same row
                <Row className={'px-2'} align="middle" wrap={false} gutter={0}>
                    <Col flex="70px">
                        <Avatar src={formatCompanyLogoUrl()}/>
                    </Col>
                    <Col flex="auto" className="title-container">
                        <Typography.Text level={5} className="portfolio-title">
                            {portfolio.name}
                        </Typography.Text>
                    </Col>
                </Row>
            )}
            <Row className={'py-3 px-2'}>
                {description && (
                    <Paragraph style={{fontSize: '0.75rem', fontFamily: "Inter, sans-serif", fontWeight: '500'}}
                               ellipsis={{ rows: maxLines, expandable: false }}
                    >
                        {description}
                    </Paragraph>
                )}
            </Row>
        </Card>
    );
};

export default PortfolioSquare;
